export const DEFAULT_METRIC_VALUE_RESULT_VARIABLE = "value";
export const DEFAULT_METRIC_COMPARISON_RESULT_VARIABLE = "comparison_value";
